import Siprec from './factory/Siprec'
import Locale from '@/locale'
import Configuration from '@/models/Configuration'

export default Siprec({
  name: 'companies',
  methods: {
    saveConfiguration (company, configuration) {
      configuration.company = company
      if (!configuration._self) {
        return Configuration.create(configuration)
      } else {
        return Configuration.update(configuration)
      }
    }
  },
  enums: {
    passwordComplexity: {
      '2': Locale.t('passwordComplexity.low'),
      '3': Locale.t('passwordComplexity.medium'),
      '4': Locale.t('passwordComplexity.high')
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/Company.js